<template>
  <div :class="['team-size-select', className ? className : '']">
    <div class="description">
      {{ label }}
    </div>
    <div class="select">
      <div
        :class="['dropdown', isShowSelectionList ? 'active' : '']"
        @click="showSelect"
      >
        <div
          :key="selectedItem.text"
          class="text"
        >
          {{ selectedItem.text }}
        </div>
        <webix-ui
          class="arrow-icon"
          :config="icons.arrowMore"
        />
      </div>
      <div
        v-if="isShowSelectionList"
        class="list gantt_scroll"
      >
        <div
          v-for="(item, index) in list"
          :key="index"
          :class="['select-item', item.count === selectedItem.count ? 'active' : '', item.disabled ? 'disabled' : '']"
          :style="item.discount_label ? {pointerEvents: 'none', lineHeight: 1.5, padding: '6px 12px'} : null"
          @click="onSelectItem(item)"
        >
          <div
            v-if="item.discount_label"
            :style="{color: '#808080', textTransform: 'uppercase', overflow: 'hidden', textOverflow: 'ellipsis'}"
          >
            {{ item.discount_label }}
          </div>
          <div v-else>
            <p class="select-item__text">
              <span>{{ item.count }}</span> {{ item.count === 1 ? locales('one_user_locale') : locales('users_locale') }}
            </p>
            <div
              v-if="!isAnnual && item.count === 1"
              class="select-item__icon tooltip-gantt"
              :data-key="'base_plan_info_tooltip'"
              :data-position="'bottom'"
              :data-y="0"
              :data-x="0"
            >
              <webix-ui
                class="info-icon"
                :config="icons.infoIcon"
              />
            </div>
            <div
              v-if="(!isPopup && type === 'buy-new-plan' && isAnnual && item.disabled)
                || (!isPopup && type === 'buy-new-plan' && !isAnnual && item.disabled && item.count !== 1)"
              class="select-item__icon tooltip-gantt"
              :data-key="'can_not_use_plan'"
              :data-position="'bottom'"
              :data-y="0"
              :data-x="0"
            >
              <webix-ui
                class="info-icon"
                :config="icons.infoIcon"
              />
            </div>
          </div>
        </div>
        <div
          class="select-item contact-item"
          @click="contactClick"
        >
          {{ locales('contact_item') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import plansModel from '../../../models/plans';

import svgIconForVue from '../../common/svgIconForVue';
import arrowMoreIcon from '../../../svg/ic_arrow_more_blue.svg';
import infoIcon from '../../../svg/ic_info.svg';
import app from '$$app';

export default {
  props: {
    isPopup: { type: Boolean, required: false, default: false },
    isAnnual: { type: Boolean, required: false, default: false },
    className: { type: String, required: false, default: '' },
    label: { type: String, required: true, default: '' },
    type: { type: String, required: false, default: '' },
    plan: { type: Object, required: true, default: () => {} },
    list: { type: Array, required: true, default: () => [] },
    selected: { type: Object, required: true, default: () => {} },
  },
  emits: { onChange: Object },
  data() {
    return {
      locales: __,
      isShowSelectionList: false,
      selectedItem: null,
      icons: {
        arrowMore: svgIconForVue(arrowMoreIcon, 16, 16),
        infoIcon: svgIconForVue(infoIcon, 24, 24),
      },
    };
  },
  computed: {
    userCount() {
      return plansModel.getUserCount();
    },
    isTrial() {
      return plansModel.isTrial();
    },
  },
  watch: {
    selected: {
      handler(selected) {
        if (selected.text.includes('+')) {
          selected.text = selected.text.replace('+', '').trim();
        }

        this.selectedItem = selected;
      },
      immediate: true,
    },
  },
  mounted() {
    document.addEventListener('click', this.hideSelect);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.hideSelect);
  },
  methods: {
    showSelect() {
      this.isShowSelectionList = true;
    },
    hideSelect(e) {
      if (e.target.closest('.popup_proto_shadow') || e.target.closest('.message-us-form')) {
        return;
      }
      if (!this.$el.contains(e.target)) {
        this.isShowSelectionList = false;
      }
    },
    onSelectItem(item) {
      if (item.disabled) {
        return;
      }
      // this.$store.commit('paymentClient/setNextCount', item.count);
      this.$emit('onChange', item);
      this.isShowSelectionList = false;
    },
    contactClick() {
      const planName = this.plan.name;

      app.trigger('messageUsForm:show', 'price-app-contact-us-form', planName);
    },
  },
};
</script>

<style scoped src="../less/select.less"></style>
<style lang="less">
.select-item__text {
  margin-bottom: 0 !important;
}

.arrow-icon {
  .webix_view {
    cursor: pointer;
  }
}

.select-item__icon {
  .info-icon {
    display: flex;
    align-items: center;
    justify-content: center;

    .webix_view {
      cursor: pointer;

      .webix_template {
        svg {
          path {
            fill: #757575;
          }
        }

        &:hover {
          svg {
            path {
              fill: #424242;
            }
          }
        }
      }
    }
  }
}
</style>
